var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isEnabled
    ? _c(
        "w-card",
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("nfc-badges-for-lockscreen")) + " "),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("press-ctrl-shift-i-to-lock-your-screen"),
                      expression:
                        "$ct('press-ctrl-shift-i-to-lock-your-screen')",
                    },
                  ],
                  staticClass: "ml",
                },
                [_c("w-fa", { attrs: { icon: "info-circle" } })],
                1
              ),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.settings"),
                      expression: "$ct('common.settings')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.settingsModal = true
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "cog" } })],
                1
              ),
            ],
            1
          ),
          _vm.badges.length == 0
            ? _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(_vm._s(_vm.$ct("no-badges-added-yet"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-list",
            [
              _vm._l(_vm.badges, function (badge) {
                return _c(
                  "w-list-item",
                  { key: badge.ID },
                  [
                    _c("w-list-item-text", [_vm._v(_vm._s(badge.Label))]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("edit-badge"),
                                expression: "$ct('edit-badge')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.editBadge(badge)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("delete-badge"),
                                expression: "$ct('delete-badge')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleteBadge(badge)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                {
                  attrs: { disabled: _vm.addDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.addClicked()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("add-badge"))),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _vm.addBadgeModal
            ? _c("app-add-modal", {
                attrs: { "existing-badges": _vm.badges },
                on: {
                  close: function ($event) {
                    _vm.addBadgeModal = false
                  },
                  refresh: function ($event) {
                    return _vm.refresh()
                  },
                },
              })
            : _vm._e(),
          _vm.settingsModal
            ? _c("app-lock-screen-settings-modal", {
                on: {
                  close: function ($event) {
                    _vm.settingsModal = false
                  },
                },
              })
            : _vm._e(),
          _vm.toEditBadge
            ? _c("app-lock-screen-nfc-badges-edit-modal", {
                attrs: {
                  "existing-badges": _vm.badges,
                  value: _vm.toEditBadge,
                },
                on: {
                  refresh: function ($event) {
                    return _vm.refresh()
                  },
                  close: function ($event) {
                    _vm.toEditBadge = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }